import { render } from "./customer_profile_view.html?vue&type=template&id=220ae828&scoped=true&external"
import script from "./customer_profile_view.js?vue&type=script&lang=js&external"
export * from "./customer_profile_view.js?vue&type=script&lang=js&external"

import "../../assets/css/new_style.css?vue&type=style&index=0&id=220ae828&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-220ae828"]])

export default __exports__